import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { log } from 'src/services/LogService.ts';
import ErrorMsg from 'src/ui/ErrorMsg';

export interface VXErrorBoundaryDO {
  component: React.ReactNode;
}

function ErrorFallback() {
  return <ErrorMsg />;
}

export default function VXErrorBoundary({ component }: VXErrorBoundaryDO) {
  const [className] = useState('VXErrorBoundary-' + new Date().getTime());

  function errorHandler(error: unknown, info: { componentStack?: string | null }) {
    log.debug(className, 'MSG001', String(error), { info });
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={errorHandler}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <> {component}</>
    </ErrorBoundary>
  );
}
